/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponseUserWeeklyScheduleDto } from '../../models/response-user-weekly-schedule-dto';

export interface UserWeeklyScheduleControllerFindOne$Params {

/**
 * Tenant identifier
 */
  tenant: string;

/**
 * User email
 */
  email: string;
}

export function userWeeklyScheduleControllerFindOne(http: HttpClient, rootUrl: string, params: UserWeeklyScheduleControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseUserWeeklyScheduleDto>> {
  const rb = new RequestBuilder(rootUrl, userWeeklyScheduleControllerFindOne.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('email', params.email, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseUserWeeklyScheduleDto>;
    })
  );
}

userWeeklyScheduleControllerFindOne.PATH = '/thalea-google-events/user-weekly-schedule/{tenant}/{email}';
